<template>
    <app-dialog :value="isAuthorizeReplacementDialogOpen" @input="onCloseDialog" :title="tb('Substituição do Produto')" width="50vw">
        <template v-slot:content>
            <v-row>
                <v-col cols="12" md="12" sm="12" class="pb-0">
                    <p class="font-size-md description-text mt-4">
                        {{ tb('Autorizo a substituição do produto') }} <strong>{{ product.designation }}</strong> {{ tb('por:') }}
                    </p>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="12" sm="12">
                    <v-data-table
                        class="elevation-1 nowrap-headers"
                        style="border-radius: 16px"
                        height="20vh"
                        fixed-header
                        multi-sort
                        :items="product.substitute_products"
                        :headers="tHeaders(headers)"
                        :hide-default-footer="true"
                        :no-data-text="tb('Sem dados disponíveis.')"
                        no-results-text="Não foram encontrados resultados."
                        :loading="false"
                        :loading-text="tb('A carregar dados...')"
                    >
                        <template #[`item.designation`]="scope">
                            <div class="d-flex justify-start">
                                <product-image :is-new="!!scope.item.new" :productCode="scope.item.invoice_code" :imageSrc="scope.item.image" width="35" height="35" max-width="35" max-height="35" style="cursor: pointer; position: relative" @click="openProductDetails(scope.item)"> </product-image>

                                <span class="pl-2" style="cursor: pointer" @click="openProductDetails(scope.item)">
                                    {{ scope.item.designation }}
                                </span>
                            </div>
                        </template>

                        <template #[`item.price`]="scope" class="replacement-center">
                            {{ formatPrice(scope.item.price) }}
                            <product-discounts-icon :inTable="true" class="mb-1" v-if="userStore.hasPermissionTo('View discounts icon')" :product="scope.item"></product-discounts-icon>
                        </template>

                        <template #[`item.actions`]="scope">
                            <div class="d-flex justify-space-between">
                                <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(scope.item)"> mdi-dots-horizontal-circle-outline </v-icon>

                                <v-radio-group v-model="radioSelection" class="mt-0 ml-4">
                                    <v-radio :value="scope.item.id" @change="onChangeSelectedSubstituteProduct(scope.item)">
                                        <template v-slot:label></template>
                                    </v-radio>
                                </v-radio-group>

                                <app-dialog v-if="isProductDetailsDialogOpen" :isProductDetails="true" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="tb('Ficha do Produto')" width="55vw" :isResponsive="true" :showActions="false">
                                    <template v-slot:content>
                                        <product-details :product="clickedSubstituteProduct" :key="clickedSubstituteProduct.id" viewingSubstituteProduct parentPage="prodReplacementDialog"></product-details>
                                    </template>
                                </app-dialog>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </template>

        <template v-slot:buttons>
            <v-btn v-if="previousSelectedSubstituteProduct" text outlined class="myprovet-btn-cancel px-8" @click="clearSelection">{{ tb('Limpar seleção') }}</v-btn>

            <v-btn text outlined class="myprovet-btn-ok px-8" @click="onSaveSubstituteProduct()">{{ tb('Confirmar') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useUserStore } from '@/Stores/user';

export default {
    props: {
        isAuthorizeReplacementDialogOpen: Boolean,
        selectedProduct: Object,
    },

    data: () => ({
        isProductDetailsDialogOpen: false,

        product: {
            designation: '',
            substitute_products: [],
        },

        radioSelection: null,

        previousSelectedSubstituteProduct: null,
        selectedSubstituteProduct: null,
        clickedSubstituteProduct: null,

        headers: [
            {
                text: 'Nome',
                align: 'start',
                sortable: true,
                value: 'designation',
                width: '60%',
            },
            {
                text: 'Preço Unit. (€)',
                align: 'center',
                sortable: true,
                value: 'price',
                width: '30%',
            },
            {
                text: '',
                align: 'center',
                sortable: false,
                value: 'actions',
                width: '10%',
            },
        ],
    }),

    created() {
        this.product = this.selectedProduct;
        const item = this.normalOrderStore.getProduct(this.product.id);
        this.selectedSubstituteProduct = item.selected_substitute_product ?? null;
        this.radioSelection = item.selected_substitute_product?.id ?? null;
        this.previousSelectedSubstituteProduct = this.selectedSubstituteProduct;
    },

    computed: {
        ...mapStores(useNormalOrderStore, useUserStore),
    },

    methods: {
        openProductDetails(product) {
            this.clickedSubstituteProduct = product;
            this.isProductDetailsDialogOpen = true;
        },

        onChangeSelectedSubstituteProduct(product) {
            this.selectedSubstituteProduct = product;
        },

        onCloseDialog() {
            this.$emit('onClose');
        },

        clearSelection() {
            if (!this.radioSelection) {
                this.showError(this.$t('replacement.nothingToClear'));
                return;
            }

            this.radioSelection = null;
            this.selectedSubstituteProduct = null;

            this.$emit('clear', this.selectedProduct);
            this.showSuccess(this.$t('replacement.removed'));
            this.$emit('onClose');
        },

        onSaveSubstituteProduct() {
            if (!this.radioSelection) {
                this.$emit('clear', this.selectedProduct);
                this.$emit('onClose');
                return;
            }

            let selected = false;
            this.normalOrderStore.setProductSubstitute(this.product.id, this.selectedSubstituteProduct);
            if (this.normalOrderStore.getProductCount) {
                this.normalOrderStore.getProducts.forEach((product) => {
                    if (product.selected_substitute_product) {
                        selected = true;
                    }
                });
            }

            if (selected) {
                this.showSuccess(this.$t('replacement.set'));
                this.$emit('onClose');
            } else {
                this.showError(this.$t('replacement.selectOne'));
            }
        },
    },
};
</script>
